import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function ContactUs() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <a id="cu-newspaper" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            紙面へのご意見、掲載写真のご注文
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 読者センター</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7105<br/>
              受付時間　午前９時30分～午後５時00分（土・日・祝日を除く）<br/>
              {/* 
              <MailOutlineIcon /><a href="mailto:kouhou@daily-tohoku.co.jp">kouhou@daily-tohoku.co.jp</a><br/>
              <div className="fs90 line150 text-danger">
                ※頂いたメールには、係が必ず目を通しますが、回答や返答を必ずお約束するものではありません。ご了承ください。
              </div>
               */}
            </dd>
          </dl>
          <Box my={0} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-shimen" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  紙面のお問い合わせフォームはこちら
                </CustomButton>
                <div className="fs90 line150 text-danger">
                  ※頂いたお問い合わせには、係が必ず目を通しますが、回答や返答を必ずお約束するものではありません。ご了承ください。
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomButton href="/printservice" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  掲載写真・紙面プリントサービスのご案内
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="cu-sales" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            新聞広告のお申し込み、広告料のお支払い
          </Typography>
          <dl>
            <dt>デーリー東北新聞社　地域ビジネス部・営業部門</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7095<br/>
              <i className="fas fa-fax mx-1"></i> 0178-24-4619<br/>
              受付時間　午前９時30分～午後５時00分（土・日・祝日を除く）<br/>
            </dd>
          </dl>
        </Box>

        <a id="cu-hall" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            主催イベントのお問合せ、デーリー東北ホールのお申し込み
          </Typography>
          <dl>
            <dt>デーリー東北新聞社　地域ビジネス部・事業部門</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7299<br/>
              <i className="fas fa-fax mx-1"></i> 0178-47-0077<br/>
              受付時間　午前9時30分～午後５時00分（土・日・祝日を除く）<br/>
            </dd>
          </dl>
        </Box>

        <a id="cu-ticket" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            チケットについてのお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社　チケットセンター（デーリー東北新聞社内）</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-73-2882（直通）<br/>
              受付時間　午前10時00分～午後４時00分（土・日・祝日を除く）<br/>
            </dd>
          </dl>
        </Box>

        <a id="cu-delion" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー友の会についてのお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社「デーリー友の会」事務局</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-44-3131<br/>
              受付時間　午前10時00分～午後５時00分（土・日・祝日を除く）<br/>
            </dd>
          </dl>
        </Box>

        <a id="cu-press" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            取材に関するお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 報道部</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7017<br/>
              <i className="fas fa-fax mx-1"></i> 0178-45-5888<br/>
              {/* <MailOutlineIcon /><a href="mailto:houdou@daily-tohoku.co.jp">houdou@daily-tohoku.co.jp</a><br/> */}
              受付時間　平日の午前９時30分～午後11時00分（土・日・祝日は午前10時00分〜）<br/>
            </dd>
          </dl>
          <Box my={0} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-interview" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お問い合わせフォームはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="cu-hiroba" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ひろば面（イベント情報掲載・こだま等）に関するお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 報道部ひろば担当</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7138<br/>
              <i className="fas fa-fax mx-1"></i> 0178-45-5888<br/>
              {/* <MailOutlineIcon /><a href="mailto:chiki@daily-tohoku.co.jp">chiki@daily-tohoku.co.jp</a><br/> */}
              受付時間　午前10時～午後７時00分<br/>
            </dd>
          </dl>
          <Box my={0} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-hiroba" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お問い合わせフォームはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="cu-culture" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            文化面、ヤングポスト面、ライフ面に関するお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 文化部</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7173<br/>
              <i className="fas fa-fax mx-1"></i> 0178-45-5888<br/>
              {/* 
              <MailOutlineIcon /><a href="mailto:bunka@daily-tohoku.co.jp">bunka@daily-tohoku.co.jp（文化全般）</a><br/>
              <MailOutlineIcon /><a href="mailto:bungei@daily-tohoku.co.jp">bungei@daily-tohoku.co.jp（文芸コーナー）</a><br/>
              <MailOutlineIcon /><a href="mailto:young@daily-tohoku.co.jp">young@daily-tohoku.co.jp（ヤングポスト）</a><br/>
              <MailOutlineIcon /><a href="mailto:turi-info@daily-tohoku.co.jp">turi-info@daily-tohoku.co.jp（釣果じまん）</a><br/>
               */}
              受付時間　午前９時30分～午後７時00分<br/>
            </dd>
          </dl>
          <Box my={0} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-bunka" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  文化全般のお問い合わせフォームはこちら
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-bungei" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  文芸コーナーのお問い合わせフォームはこちら
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-youngpost" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  ヤングポストのお問い合わせフォームはこちら
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-turi" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  釣果じまんのお問い合わせフォームはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="cu-book" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北の書籍のご注文・お問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社　出版部</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7204<br/>
              <i class="fas fa-fax mx-1"></i> 0178-44-5126<br/>
              受付時間　午前9時30分～午後５時00分（土・日・祝日を除く）<br/>
              {/* <MailOutlineIcon /><a href="mailto:shuppan@daily-tohoku.co.jp">shuppan@daily-tohoku.co.jp</a><br/> */}
            </dd>
          </dl>
          <Box my={0} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-book" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お問い合わせフォームはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="cu-web" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            ウェブサイトの内容に関するお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 読者センター</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7105<br/>
              受付時間　午前9時30分～午後５時00分（土・日・祝日を除く）<br/>
              {/* <MailOutlineIcon /><a href="mailto:media@daily-tohoku.co.jp">media@daily-tohoku.co.jp</a><br/> */}
            </dd>
          </dl>
          <Box my={0} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-web" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お問い合わせフォームはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
          <div className="fs90 line150 text-danger">
            ※頂いたお問い合わせには、係が必ず目を通しますが、回答や返答を必ずお約束するものではありません。ご了承ください。<br/>
            ※紙面に掲載された記事に関するお問い合わせは、読者センターで受け付けます。<br/>
          </div>
        </Box>

        <a id="cu-user" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            アプリやウェブサイトの登録、閲覧、料金に関するお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社統合編集局デジタル本部</dt>
            <dd>
              {/* <PhoneEnabledIcon /> 0178-80-7105<br/>
              受付時間　午前9時30分～午後５時00分（土・日・祝日を除く）<br/> */}
              {/* <MailOutlineIcon /><a href="mailto:dtdinfo@daily-tohoku.co.jp">dtdinfo@daily-tohoku.co.jp</a><br/> */}
            </dd>
          </dl>
          <Box my={0} textAlign="center">
            <Grid className="px-3" spacing={0} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <CustomButton href="https://form.daily-tohoku.org/contact-daily-digital" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  お問い合わせフォームはこちら
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
          <div className="fs90 line150 text-danger">
            ※頂いたお問い合わせには、係が必ず目を通しますが、回答や返答を必ずお約束するものではありません。ご了承ください。<br/>
          </div>
        </Box>

        <a id="cu-etc" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            その他のお問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 総務部</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-44-5111<br/>
              <i class="fas fa-fax mx-1"></i> 0178-47-0841<br/>
              受付時間　午前９時30分～午後５時00分（土・日・祝日を除く）<br/>
            </dd>
          </dl>
        </Box>

{/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            著作権について
          </Typography>
          　デーリー東北(本紙、ホームページ)に掲載された記事、写真、動画、イラストなどの著作権は、デーリー東北新聞社および配信した通信社など各情報提供者にあります。無断転載、再配信等は固くお断りします。<br/>
          　著作権については、日本新聞協会の見解に準拠します。<br/>

          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/daily-right" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            当サイトについて
          </Typography>
          <dl>
            <dt>おことわり</dt>
            <dd>
              　デーリー東北新聞社が当ウェブサイト上で提供する記事、写真、図表などの無断転載を禁止します。<br/>
              　著作権はデーリー東北新聞社またはその情報提供者に帰属します。全国、海外のニュースは共同通信社の配信を受けています。<br/>
              　ネットワーク上の著作権については<a href="https://www.pressnet.or.jp/statement/copyright/" target="_blank">日本新聞協会の見解</a>もご参照ください。<br/>
            </dd>
            <dt>推奨環境</dt>
            <dd>
              　当ウェブサイトの推奨環境は下記の通りです。
              <Box p={2}>
                <div class="font-weight-bold">
                  <ArrowRightIcon />ＰＣの場合
                </div>
                ▽ＯＳ<br/>
                Windows 7、Windows 8、Windows 10、Mac OS X 10.4以降<br/>
                ▽ブラウザ<br/>
                Internet Explorer　11.x、Firefox　最新版、Safari　最新版、Google Chrome 最新版、Microsoft Edge 最新版<br/>
              </Box>

              <Box p={2}>
                <div class="font-weight-bold">
                  <ArrowRightIcon />スマートフォンの場合
                </div>
                ▽ＯＳ<br/>
                iOS8以降、Android4.1以降<br/>
                ▽ブラウザ<br/>
                各OSで標準搭載しているブラウザ、Google Chrome<br/>
              </Box>

              <div className="fs90 line150 text-danger">
                ※推奨環境は、OSとブラウザ両方の条件を含んだ環境となります。<br/>
                ※上記環境以外では正常に表示されない場合があります。<br/>
                ※ブラウザのJavaScriptは必ずONにして閲覧してください。<br/>
                電子号外などのPDFファイルは【Adobe Reader】で見ることができます。<a href="https://get.adobe.com/reader/?loc=jp" target="_blank">入手はこちらから</a><br/>
                動画など一部コンテンツで【Adobe Flash】が使用されています。<a href="https://get.adobe.com/flashplayer/?loc=jp" target="_blank">入手はこちらから</a><br/>
              </div>
            </dd>
          </dl>
        </Box>
*/}
      </div>
    </div>
  );
}

export default ContactUs;
